import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Config } from '../config';
import { AuthenticationService } from '../services/authentication.service';
import { Department } from '../shared/models/department.model';
import { Comment } from '../shared/models/comment.model';
import { Interval } from '../shared/models/interval.model';
import { Entry } from '../shared/models/entry.model';
import { IntervalPrevSubmit } from '../shared/models/intervalPrevSubmit'; 

/**
 * Entry service (to Identity Web API controller).
 */
@Injectable() export class EntryService  {

    headers: Headers;
    options: RequestOptions;
    

    constructor(private authHttp: AuthHttp, private authenticationService: AuthenticationService) {
        // Creates header for post requests.
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });       
    }

    /**
      * Get all active departments
      */
    public getDepartments(): Observable<Department[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('userId', this.authenticationService.userSubject.value.sub);
        params.set('active', 'true');
        let cb = new Date().getTime();
        params.set('cacheBuster', cb.toString());
        this.options.search = params;
        return this.authHttp.get(Config.BaseUrl + "/api/Entry/GetDepartments", this.options)
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    /**
     * Get intervals
     */
    public getIntervals() {
        let params: URLSearchParams = new URLSearchParams();
        params.set('userId', this.authenticationService.userSubject.value.sub);
        let cb = new Date().getTime();
        params.set('cacheBuster', cb.toString());      
        this.options.search = params;
        return this.authHttp.get(Config.BaseUrl + "/api/Entry/GetIntervals", this.options)
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    /**
     * Get previous sumbittet data for interval input values
     * @param selectedDepartments 
     * @param intervals 
     */
    public getIntervalsDataPrevSubmittedValues(selectedDepartments, intervals) {
        let intervalIds: string = intervals.map(item => item.id).join(',');
        let departmentIds: string = selectedDepartments.map(item => item.id).join(',');
        let params: URLSearchParams = new URLSearchParams();
        params.set('userId', this.authenticationService.userSubject.value.sub);
        params.set('departmentIds', departmentIds);
        params.set('intervalIds', intervalIds);
        let cb = new Date().getTime();
        params.set('cacheBuster', cb.toString());
        this.options.search = params;
        return this.authHttp.get(Config.BaseUrl + "/api/Entry/GetIntervalData", this.options)
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    /**
     * Submitting an entry report
     * @param entrys 
     */
    public submitEntryReport(entrys): Observable<Entry[]> {
        console.log(entrys);
        let params: URLSearchParams = new URLSearchParams();
        params.set('userId', this.authenticationService.userSubject.value.sub);
        this.options.search = params;
        let body = entrys.entrys; 
        return this.authHttp.post(Config.BaseUrl + "/api/Entry/SubmitEntry", body, this.options)
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });    
    }

    /**
     * Delete comment from department
     * @param commentId 
     */
    public deleteComment(commentId: number) {
        let cId: string = commentId.toString();
        let params: URLSearchParams = new URLSearchParams();
        params.set('commentId', cId);
        this.options.search = params;
        return this.authHttp.post(Config.BaseUrl + "/api/Entry/DeleteComment", cId,this.options)
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });    
    }

}
